/* global axios */

import ApiClient from '../ApiClient';

class VtexAPI extends ApiClient {
  constructor() {
    super('integrations/vtex', { accountScoped: true });
  }

  getCustomer(contactId, inboxId) {
    return axios.get(`${this.url}/customer`, {
      params: { contact_id: contactId, inbox_id: inboxId },
    });
  }

  createCustomer(contactId, inboxId, customer = {}) {
    return axios.post(`${this.url}/customer`, {
      contact_id: contactId,
      inbox_id: inboxId,
      customer,
    });
  }

  getOrders(contactId, inboxId) {
    return axios.get(`${this.url}/orders`, {
      params: { contact_id: contactId, inbox_id: inboxId },
    });
  }

  getDraftOrders(contactId, inboxId) {
    return axios.get(`${this.url}/draft_orders`, {
      params: { contact_id: contactId, inbox_id: inboxId },
    });
  }

  createDraftOrder(payload) {
    return axios.post(`${this.url}/draft_orders`, payload);
  }

  updateDraftOrder(id, payload) {
    return axios.patch(`${this.url}/draft_orders/${id}`, payload);
  }

  deleteDraftOrder(id) {
    return axios.delete(`${this.url}/draft_orders/${id}`);
  }

  approveDraftOrder(id) {
    return axios.post(`${this.url}/draft_orders/${id}/approve`);
  }

  confirmDraftOrder(id, payload) {
    return axios.post(`${this.url}/draft_orders/${id}/confirm`, payload);
  }

  getDraftOrderStatus(id) {
    return axios.get(`${this.url}/draft_orders/${id}/status`);
  }

  searchProducts(query, inboxId) {
    return axios.get(`${this.url}/products/search`, {
      params: { q: query, inbox_id: inboxId },
    });
  }

  triggerCatalogSync() {
    return axios.post(`${this.url}/catalog_sync`);
  }
}

export default new VtexAPI();
